export default __webpack_public_path__ + "static/media/FlipBook.f0ced4b31c7b1c6386fd165bf9c6617f.webp";